import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ToastService } from '@shared/components/toast';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ParticipantApiService } from '../../api/participant-api.service';
import { FileUploaderModel } from '../../models/file-uploader.model';

@Component({
  selector: 'portal-signing-confirm-submit-bottom-sheet',
  templateUrl: './confirm-submit-bottom-sheet.component.html',
  styleUrls: ['./confirm-submit-bottom-sheet.component.scss'],
})
export class ConfirmSubmitBottomSheetComponent implements OnDestroy {
  // Upload
  messageUploadFile = 'Support files under 5MB.';
  maxFiles = 5;
  maxCurrentSlot!: number;
  maxFileSize = this.maxFiles * 1024 * 1024;
  allowedMimeTypes = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/bmp',
    'image/gif',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/csv',
    'text/plain',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  allowExtensions = ['png', 'bmp', 'gif', 'jpeg', 'jpg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv'];
  uploadSelection = new SelectionModel<FileUploaderModel>(true);

  accessToken: string;
  unsubscribeAll = new Subject<void>();
  constructor(
    private bottomSheetRef: MatBottomSheetRef<ConfirmSubmitBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) private data: { attachments: FileUploaderModel[]; accessToken: string },
    private participantApiService: ParticipantApiService,
    private toastService: ToastService,
  ) {
    if (!this.data?.accessToken) {
      throw new Error('accessToken is required');
    }
    this.accessToken = this.data.accessToken;
    this.uploadSelection.select(...this.data.attachments);
    this.calculateAvailableSlot();

    this.bottomSheetRef
      .backdropClick()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(() => {
        this.submit();
      });
  }
  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  onAddPhoto(data: FileUploaderModel): void {
    if (data.error?.status) {
      this.toastService.notify({ type: 'danger', messages: data.error?.message ?? '' });
    } else {
      this.uploadSelection.select(data);
      this.calculateAvailableSlot();
    }
  }

  onRemovePhotos(data: FileUploaderModel[]): void {
    for (let i = 0; i < data.length; i++) {
      this.onRemovePhoto(data[i]);
    }
  }

  onRemovePhoto(data: FileUploaderModel): void {
    this.uploadSelection.deselect(data);
    this.calculateAvailableSlot();
  }

  comfirmFullSlot(): void {
    const msg = `Maximum ${this.maxFiles} file(s)`;
    // this.isUpLoading = false;
    this.toastService.notify({ type: 'danger', messages: msg });
  }

  calculateAvailableSlot(): void {
    this.maxCurrentSlot = this.maxFiles - this.uploadSelection.selected.length;
  }
  getUploadLink(data: { type: any; name: any; acl?: any }): Observable<any> {
    return this.participantApiService.getUploadLink(this.accessToken, data);
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
  submit(): void {
    this.bottomSheetRef.dismiss(this.uploadSelection.selected);
  }
}
